module.exports = __webpack_public_path__ + "img/unsubscribe-icon.945a477d.png";